import React, { useState, useEffect } from 'react';
import styles from './AboutCarousel.module.css';

const images = [
  'https://assets.cinbiosis.com/reel_people/nosotros1.jpg',
  'https://assets.cinbiosis.com/reel_people/nosotros2.jpg',
  'https://assets.cinbiosis.com/reel_people/nosotros3.jpg',
  'https://assets.cinbiosis.com/reel_people/nosotros4.jpg'
];

const AboutCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // Preload images to add a cache in case they are already downloaded
    images.forEach(src => {
      const img = new Image();
      img.src = src;
    });

    // Change image every 3.5 seconds
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3500);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className={styles.carouselContainer}>
      {images.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`Cinbiosis Team Reel ${index + 1}`}
          className={`${styles.carouselImage} ${index === currentIndex ? styles.active : ''}`}
        />
      ))}
    </div>
  );
};

export default AboutCarousel;
